import { BaseCommand } from './baseCommand';
import Element, { ElementType } from '../element';
import { WallModel } from '../wallModel';
import { wallManager } from '../wallManager';
import store from '@/store';
import { messager } from '../messager';

export class HandleWallSupportsCommand extends BaseCommand {

    private removedSupports: Element[] = [];

    constructor(
        scenePreview: any,
    ) {
        super(scenePreview);
    }

    public execute(): void {
        const walls = this.getExistingWallsAsWallModels();
        const existingSupports = this.getExistingSupports();
        const supports = this.calculateNecessarySupports(walls);
        this.addNecessarySupports(supports, existingSupports);
        this.removeUnnecessarySupports(existingSupports, supports);
    }

    public revert() {
        this.removeElements();
        this.revertCommands();
        this.removedSupports.forEach((x) => {
            x.isVisible = true;
            this.scenePreview.elements.push(x);
        });
    }

    private getExistingWallsAsWallModels(): WallModel[] {
        return this.scenePreview.elements
            .filter((e: Element) => e.type === ElementType.WALL)
            .map((e: Element) => this.toWallModel(e));
    }

    private getExistingSupports(): Element[] {
        return this.scenePreview.elements
            .filter((e: Element) => e.type === ElementType.WALL_SUPPORT);
    }

    private calculateNecessarySupports(walls: WallModel[]): WallModel[] {
        const supports: WallModel[] = [];
        supports.push(...wallManager.createWallSupports(walls));
        supports.push(...wallManager.createCellingSupports([]));
        return supports;
    }

    private addNecessarySupports(supports: WallModel[], existingSupports: Element[]) {
        const cachedSupports: WallModel[] = [];
        const shader = store.getters.shaders.selectedSupport;
        supports.forEach((s) => {
            if (this.isUnique(s, existingSupports, cachedSupports)) {
                cachedSupports.push(s);
                this.scenePreview.addElement(
                    s.model,
                    s.light,
                    shader,
                    s.position,
                    s.shape,
                    (wall: Element) => {
                        this.elements.push(wall);
                        if (this.elements.length === cachedSupports.length) {
                            const text = this.scenePreview.$t('addedSupport').toString();
                            messager.info(text);
                        }
                    });
            }
        });
    }

    private isUnique(
        s: WallModel,
        existingSupports: Element[],
        cachedSupports: WallModel[]): boolean {
        return (
            !existingSupports.some((es) =>
                es.position.x === s.position.x && es.position.y === s.position.y) &&
            !cachedSupports.some((cs) =>
                cs.position.x === s.position.x && cs.position.y === s.position.y)
        );
    }

    private removeUnnecessarySupports(existingSupports: Element[], supports: WallModel[]) {
        existingSupports.forEach((es) => {
            if (!supports.some((s) =>
                es.position.x === s.position.x && es.position.y === s.position.y)) {
                this.removedSupports.push(es);
                es.isVisible = false;
                this.scenePreview.elements.splice(
                    this.scenePreview.elements.indexOf(es), 1,
                );
            }
        });
    }

    private toWallModel(element: Element): WallModel {
        return new WallModel(
            element.model,
            element.light,
            element.position.clone(),
            element.shape.clone(),
        );
    }
}
